import { render, staticRenderFns } from "./orderdetailedList.vue?vue&type=template&id=461a5298&scoped=true"
import script from "./orderdetailedList.vue?vue&type=script&lang=js"
export * from "./orderdetailedList.vue?vue&type=script&lang=js"
import style0 from "./orderdetailedList.vue?vue&type=style&index=0&id=461a5298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a5298",
  null
  
)

export default component.exports